import { useEffect, useState, forwardRef } from 'react'
import { clientListBySystemUserInfo } from 'api/api'
import {
	Grid,
	Box,
	Button,
	TextField,
	Typography,
	Dialog,
	DialogContent,
	useMediaQuery,
	useTheme,
	styled,
} from '@mui/material'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import {
	DataGridPremium,
	koKR,
	GridColDef,
	GridSelectionModel,
	GridRowModel,
	GridApi,
	useGridApiRef,
	GridDensity,
} from '@mui/x-data-grid-premium'
import { valuesInIterator } from 'util/objectUtil'
import { getSettings } from 'helpers/storage'
import { InfoClientSearchForInternal } from 'constants/types'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import BookmarkAddedTwoToneIcon from '@mui/icons-material/BookmarkAddedTwoTone'
import { selectuserInfo } from 'hooks/userInfo'
import { useSelector } from 'react-redux'

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement
	},
	ref: React.Ref<unknown>,
) {
	return (
		<Slide
			direction="up"
			ref={ref}
			{...props}
		/>
	)
})

const columns: GridColDef[] = [
	{
		field: 'rowNum',
		headerName: '번호',
		type: 'number',
		width: 100,
		editable: false,
		hide: true,
	},
	{
		field: 'ClientID',
		headerName: '거래처코드',
		type: 'string',
		width: 80,
		editable: false,
	},
	{
		field: 'ClientName',
		headerName: '거래처명',
		type: 'string',
		width: 250,
		editable: false,
	},
]

const SearchConditionBox = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	flex: '0 1 auto',
	alignItems: 'center',
	'.MuiTextField-root': {
		width: '100%',
	},
	'.searchField': {
		flex: '1 0 auto',
	},
	'.wrap': {
		display: 'flex',
		marginLeft: '1rem',
		gap: '10px',
	},
}))

const ClientSearchPopup = ({ dialogOpen, dialogClose, popupSubmit }: any) => {
	const env = getSettings()
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))

	const userInfo = useSelector(selectuserInfo)

	const [searchCondition, setSearchCondition] =
		useState<InfoClientSearchForInternal>({
			ClientID: '',
			ClientName: '',
			BranchCode: userInfo?.infoType === 'S' ? userInfo?.branchCode : '',
		})
	const [searchList, setSearchList] = useState<any[]>([])

	const popupSearchAction = () => {
		console.log(searchCondition)
		clientListBySystemUserInfo(searchCondition).then((res) => {
			setSearchList(res)
			// select first row
			setTimeout(() => {
				setSelectionModel([0])
			}, 100)
		})
	}

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) popupSearchAction()
	}

	// grid
	const apiRef = useGridApiRef()
	const [gridApi, setGridApi] = useState<GridApi | null>(null)
	const [gridSelectionModel, setGridSelectionModel] =
		useState<GridSelectionModel>([])
	const [gridRows, setGridRows] = useState<GridRowModel[]>([])
	const [gridLoading, setGridLoading] = useState(false)
	const [gridPageSize, setGridPageSize] = useState(10)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])
	const [checkLength, setCheckLength] = useState<number>(0)

	const [selectedRow, setSelectedRow] = useState<any>([])

	const formSubmit = () => {
		const row = valuesInIterator(apiRef.current?.getSelectedRows())
		if (row.length > 0) popupSubmit(row[0])
	}

	useEffect(() => {
		// popupSearchAction()
	}, [])

	return (
		<Dialog
			fullScreen={isMdUp ? false : true}
			open={dialogOpen}
			onClose={dialogClose}
			TransitionComponent={Transition}
			maxWidth="lg"
		>
			<AppBar sx={{ position: 'relative' }}>
				<Toolbar variant="dense">
					<Typography
						sx={{ ml: 2, flex: 1 }}
						variant="h6"
						component="div"
					>
						거래처 조회
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						onClick={dialogClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<Box
					component="div"
					onKeyUp={onKeyUp}
				>
					<SearchConditionBox>
						<Grid
							container
							spacing={1}
							sx={{ mt: 1 }}
						>
							<Grid
								item
								sm={4}
								xs={12}
							>
								<TextField
									label="거래처코드"
									variant="outlined"
									value={searchCondition.ClientID}
									size="small"
									onChange={(e) => {
										setSearchCondition({
											...searchCondition,
											ClientID: e.target.value ? parseInt(e.target.value) : '',
										})
									}}
								/>
							</Grid>
							<Grid
								item
								sm={4}
								xs={12}
							>
								<TextField
									label="거래처명"
									variant="outlined"
									value={searchCondition.ClientName}
									size="small"
									autoFocus
									onChange={(e) => {
										setSearchCondition({
											...searchCondition,
											ClientName: e.target.value || '',
										})
									}}
								/>
							</Grid>
							<Grid
								item
								sm={4}
								xs={12}
							>
								<Button
									color="success"
									variant="contained"
									onClick={popupSearchAction}
									startIcon={<ContentPasteSearchTwoToneIcon />}
									sx={{ mr: 1 }}
								>
									검색
								</Button>
								<Button
									color="info"
									variant="contained"
									onClick={formSubmit}
									startIcon={<BookmarkAddedTwoToneIcon />}
									disabled={selectionModel.length === 0}
								>
									선택
								</Button>
							</Grid>
						</Grid>
					</SearchConditionBox>
				</Box>
				<Grid
					container
					spacing={1}
					sx={{ mt: 1 }}
				>
					<Grid
						item
						xs={12}
					>
						<div style={{ height: 400, width: '100%' }}>
							<DataGridPremium
								apiRef={apiRef}
								rows={searchList}
								columns={columns}
								getRowId={(row) => row.rowNum}
								pageSize={env.row ? env.row : 100}
								onPageSizeChange={(newPageSize) => setGridPageSize(newPageSize)}
								rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100]}
								pagination
								selectionModel={selectionModel}
								onSelectionModelChange={(newSelectionModel) => {
									setSelectionModel(newSelectionModel)
								}}
								localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
								density={(env.desnse as GridDensity) || 'standard'}
								onRowDoubleClick={formSubmit}
							/>
						</div>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	)
}

export default ClientSearchPopup
